import {
  AppNotification,
  NotificationType,
} from '../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../utils/useDeleteDebounce'

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useArchiveMultipleMismatchTypeMutation } from 'core/api/TypeMismatchApi'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'

interface UseDeleteTypeMismatchResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteTypeMismatch = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteTypeMismatchResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleMismatchType] = useArchiveMultipleMismatchTypeMutation()
  const { t } = useTranslation()

  const deleteMismatchTypeHandler = async () => {
    if (!!chooseItems) {
      archiveMultipleMismatchType({
        non_compliant_types: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные типы несоответствий успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteMismatchTypeHandler,
    extraText: t('Выбранные вами типы несоответствий будут удалены!'),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler: openDeletePopup,
    onDeleteHandler,
    closeDeletePopup,
  }
}
